import { Vue, Component } from 'vue-property-decorator'
import declOfNum from '~/utils/declOfNum'

@Component
export default class PharmaciesHeader extends Vue {
  get textCount (): string {
    return declOfNum(10, [
      'аптека',
      'аптеки',
      'аптек'
    ])
  }

  render () {
    return (
      <div class="pharmacies-header">
        <h1 class="pharmacies-header__header">
          Аптеки
        </h1>
        <div class="pharmacies-header__count">
          98 {this.textCount}
        </div>
      </div>
    )
  }
}
